export const SELECT_ORGANIZATION = "SELECT_ORGANIZATION";
export const CLEAR_ORGANIZATION = "CLEAR_ORGANIZATION";

export const SET_FEEDBACK = "SET_FEEDBACK";
export const CLEAR_FEEDBACK = "CLEAR_FEEDBACK";